export const PAYMENT_METHOD_TEXT_OPTIONS = [
  { value: 'Con Tarjeta de Crédito Macro' },
  { value: 'Con Tarjetas de Crédito Macro' },
  { value: 'Con Tarjeta de Crédito Visa Macro' },
  { value: 'Con Tarjetas de Crédito Visa Macro' },
  { value: 'Con Tarjeta de Crédito Mastercard Macro' },
  { value: 'Con Tarjetas de Crédito Mastercard Macro' },
  { value: 'Con Tarjeta de Crédito Visa y Mastercard Macro' },
  { value: 'Con Tarjetas de Crédito Visa y Mastercard Macro' },
  { value: 'Con todas tus Tarjetas de Crédito Macro' }
];

export const PAYMENT_METHOD_TEXT_OPTIONS_SELECTA = [
  ...PAYMENT_METHOD_TEXT_OPTIONS,
  { value: 'Con Tarjetas de Crédito Visa Signature Macro Selecta' }
];
